// extracted by mini-css-extract-plugin
module.exports = {"calendarContentHolder":"CalendarSidebar_calendarContentHolder__3iR-l","calendarContentHolderNonPresenter":"CalendarSidebar_calendarContentHolderNonPresenter__1hujj"};